import { Map } from 'immutable';
import actionTypes from '../../actions/actionTypes'
import { returnStateIfNoAction } from '../helpers'
import requestStatus from '../../constants/requestStatus';

const INIT_STATE = Map({
    requestOverlay: Map({
        overlayType: false,                           //false|overlayTypes
        requestType: false                            //requestTypes                        
    })
})

const setRequestOverlayKeyValue = (state, key, value) => state.setIn(['requestOverlay', key], value)

const resetRequestOverlay = state => state.set('requestOverlay', INIT_STATE.get('requestOverlay'))
                                        


function generalReducer(state = INIT_STATE, action) {
    returnStateIfNoAction(action, state) 

    switch(action.type){
        case actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_OVERLAY_TYPE:
            return setRequestOverlayKeyValue(state, 'overlayType', action.payload.overlayType)
        case actionTypes.UI_GENERAL_REQUEST_OVERLAY_SET_REQUEST_TYPE:
            return setRequestOverlayKeyValue(state, 'requestType', action.payload.requestType)
        case actionTypes.UI_GENERAL_REQUEST_OVERLAY_RESET:
            return resetRequestOverlay(state)
        default:
            return state;
    }
}

export default generalReducer;